import React from "react";
import styled from "styled-components";
import { IconButton, Tooltip } from "@mui/material";
import FontStyle from "../styles/fontStyles";
import HelpIcon from "@mui/icons-material/Help";

type TooltipProps = {
  tip: string;
  title: string;
};

const TollTipView = styled.div(({ theme }) => {
  const { spacing } = theme as any;
  return {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",

    backgroundColor: "white",
    borderRadius: spacing(0.5),
    boxShadow: "0px 3px 6px #00000029",
    padding: spacing(2.5),
  };
});

const Title = styled.p(({ theme }) => {
  const { spacing, palette: colors } = theme as any;
  return {
    ...FontStyle.bold14,
    marginBottom: spacing(1.2),
    color: colors.text.secondary,
    marginTop: 0,
  };
});

const Content = styled.p(({ theme }) => {
  const { palette: colors, spacing, breakpoints } = theme as any;
  return {
    ...FontStyle.medium16,
    color: colors.text.secondary,
    margin: 0,
    maxWidth: spacing(59),
    textAlign: "start",
    marginBottom: spacing(1),
    [breakpoints.down("lg")]: {
      maxWidth: spacing(38),
    },
  };
});

const InfosButton = styled(IconButton)(({ theme }) => {
  const { spacing } = theme as any;
  return {
    width: spacing(2),
    height: "auto",
    margin: 0,
    padding: 0,
    marginInline: spacing(1),
  };
});

const InfoIcon = styled(HelpIcon)(({ theme }) => {
  const { spacing, palette: colors } = theme as any;
  return {
    width: spacing(2),
    height: "auto",
    color: colors.text.tertiary,
  };
});

const StyledTooltip = styled(Tooltip)({
  "& .MuiTooltip-tooltip": {
    color: "black",
    backgroundColor: "transparent",
    maxWidth: "34.375rem",
  },
});

function Tolltip({ tip, title }: TooltipProps) {
  return (
    <StyledTooltip
      title={
        <TollTipView>
          <Title>{title}</Title>
          <Content>{tip}</Content>
        </TollTipView>
      }
      slotProps={{
        tooltip: {
          sx: {
            color: "black",
            backgroundColor: "transparent",
            maxWidth: "34.375rem",
          },
        },
      }}
    >
      <InfosButton>
        <InfoIcon />
      </InfosButton>
    </StyledTooltip>
  );
}

export default React.memo(Tolltip);
